import { render } from "./batterySystemInfo.vue?vue&type=template&id=64120760&scoped=true&ts=true"
import script from "./batterySystemInfo.vue?vue&type=script&lang=ts"
export * from "./batterySystemInfo.vue?vue&type=script&lang=ts"

import "./batterySystemInfo.vue?vue&type=style&index=0&id=64120760&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64120760"]])

export default __exports__